import React, { useContext } from "react";
import { useHistory } from "react-router-dom";

// Import Ionic
import { IonCol, IonImg, IonItem, IonLabel, IonList, IonListHeader, IonRow } from "@ionic/react";

// Import Components
import MaxWidthContainer from "../UI/MaxWidthContainer/MaxWidthContainer";

// Import Style
import classNames from "classnames/bind";
import styles from "./Footer.module.scss";
import { useConfig } from "../../providers/config";
import { applyRegExOnPhoneNumber } from "../../providers/utils/utils";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(styles);

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const config = useConfig();

  const goToPage = (path: string) => {
    history.push(path);
  };

  const { homePageCategories: { featured, latest, sale, customersChoice } = {} } = config;

  return (
    <footer className={cx("footer", "ion-hide-md-down")}>
      <div className={cx("footerContainer")}>
        <MaxWidthContainer>
          <IonRow className={cx("footerTop", { "margin-bottom": config?.isContentInFooterShown })}>
            <IonCol>
              <IonList lines={"none"} className={cx("footerList")}>
                <IonListHeader className={cx("footerListHeader")}>
                  <IonLabel>Покупателям</IonLabel>
                </IonListHeader>
                {customersChoice?.isEnabled && (
                  <IonItem>
                    <IonLabel>
                      <span
                        onClick={() => {
                          goToPage("/products/0/0/popular");
                        }}
                        className={cx("footerLink")}
                      >
                        {t(`${customersChoice.title}`)}
                      </span>
                    </IonLabel>
                  </IonItem>
                )}

                {latest?.isEnabled && (
                  <IonItem>
                    <IonLabel>
                      <span
                        onClick={() => {
                          goToPage("/products/0/0/latest");
                        }}
                        className={cx("footerLink")}
                      >
                        {t(`${latest.title}`)}
                      </span>
                    </IonLabel>
                  </IonItem>
                )}

                {featured?.isEnabled && (
                  <IonItem>
                    <IonLabel>
                      <span
                        onClick={() => {
                          goToPage("/products/0/0/featured");
                        }}
                        className={cx("footerLink")}
                      >
                        {t(`${featured.title}`)}
                      </span>
                    </IonLabel>
                  </IonItem>
                )}

                {sale?.isEnabled && (
                  <IonItem>
                    <IonLabel>
                      <span
                        onClick={() => {
                          goToPage("/products/0/0/sale");
                        }}
                        className={cx("footerLink")}
                      >
                        {t(`${sale.title}`)}
                      </span>
                    </IonLabel>
                  </IonItem>
                )}
              </IonList>
            </IonCol>
            <IonCol>
              <IonList lines={"none"} className={cx("footerList")}>
                <IonListHeader className={cx("footerListHeader")}>
                  <IonLabel>О нас</IonLabel>
                </IonListHeader>
                <IonItem>
                  <IonLabel>
                    <span onClick={() => goToPage("/contact-us")} className={cx("footerLink")}>
                      {t("Contacts")}
                    </span>
                  </IonLabel>
                </IonItem>
              </IonList>
            </IonCol>
            <IonCol className={cx("footerContacts")}>
              <a
                href={`tel:+${applyRegExOnPhoneNumber(config?.companyPhoneNumber || "")}`}
                className={cx("footerContactsPhone")}
              >
                {config?.companyPhoneNumber}
              </a>
              <p className={cx("footerContactsTitle")}>Заказывайте товары круглосуточно</p>
              <div className={cx("footerMedia")}>
                <div className={cx("footerMediaItem")}>
                  <IonImg />
                </div>
                <div className={cx("footerMediaItem")}>
                  <IonImg />
                </div>
                <div className={cx("footerMediaItem")}>
                  <IonImg />
                </div>
              </div>
            </IonCol>
          </IonRow>
          {config?.isContentInFooterShown && (
            <IonRow className={cx("footerBottom", "ion-align-items-start")}>
              <IonCol size={"6"}>
                © {config.siteDomain} -
                <span
                  onClick={() => {
                    goToPage("/privacy-policy");
                  }}
                  className={cx("footerBottomLink")}
                >
                  {config.defineSiteActivity}
                </span>
                Все права защищены.
              </IonCol>
              <IonCol size={"6"}>
                <span>Есть вопрос? Напишите нам письмо или воспользуйтесь кнопкой обратной связи.</span>
              </IonCol>
            </IonRow>
          )}
        </MaxWidthContainer>
      </div>
    </footer>
  );
};

export default Footer;
